const Facebookfeed = ({ width = 500, height = 600 }) => {
  const encodedUrl = encodeURIComponent('https://www.facebook.com/Hidalgo.Bienestar');
  
  return (
    <iframe
      src={`https://www.facebook.com/plugins/page.php?href=${encodedUrl}&tabs=timeline&width=${width}&height=${height}&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`}
      width={width}
      height={height}
      style={{ border: 'none', overflow: 'hidden', borderRadius: '0px', maxWidth: '100%' }}
      scrolling="no"
      frameBorder="0"
      allowFullScreen={true}
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      title="Facebook Feed - Hidalgo Bienestar"
    />
  );
};



export default Facebookfeed;